import React from 'react';
export const AppConfigContext = React.createContext({});
const AppContext = React.createContext({
    message: {},
    notification: {},
    modal: {},
});
export default AppContext;
